module.exports = __webpack_public_path__ + "static/media/SM-MT-12.de444d17.mp3";